import React from "react"
import RatingsHeroScrolling from './RatingHeroScrolling'

interface IProps {
  starsImage: any
  quotes: {
    text: string
    author: {
      name: string
      title: string
    }
  }[]
}

const RatingsHero = (props: IProps) => {
  // if (typeof window === 'undefined') return <Wrappe/r><RatingsHeroSSR {...props} /></Wrapper>;
  return <RatingsHeroScrolling {...props} />

}

export default RatingsHero
